import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { amountFormat } from '../../config/helper';
import { ContainerStatus } from './Cart';

const CartPopup = () => {
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  let orderDetails = localStorage.getItem("orderDetails") ? JSON.parse(localStorage.getItem("orderDetails")) : {}
  const history = useHistory()
  const addToCart = useSelector((state) => state?.orders?.addToCart);
  const [open, setCartPopup] = useState();
  //const regions = useSelector((state) => state?.orders?.origins?.data || []);
  const firstOrigin = cart?.line_items?.[0];
  // const originDetails = regions?.data?.find(
  //   o => o.id === firstOrigin?.origin_id
  // );
  const orderType = firstOrigin?.order_type;

  const normalizeOrderType = (type) =>
    type?.toLowerCase() === "ftl" ? "ftl" : "fd";

  const popupHeader =
    normalizeOrderType(orderType) === "ftl"
      ? "FULL TRUCK CAPACITY"
      : "CONTAINER CAPACITY";


  const handleClickOutside = (e) => {
    if (
      e.target?.className && e.target?.className?.includes &&
      (e.target?.className?.includes("cart-popup") ||
        e.target?.className?.includes("cart-link"))
    ) {
      return;
    }
    setCartPopup(false)
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    }
  }, [])

  useEffect(() => {
    if (addToCart.success) {
      setCartPopup(true);
    }
  }, [addToCart])

  return (
    open ? <div className="cart-popup">
      <div className="head">
        <span className="p1">{"Cart Details"}</span>
        <span
          className="cursor go-to-cart"
          onClick={() => {
            setCartPopup(false);
            history.push("/cart", {
              orderDetails,
            });
          }}
        >
          Go to Cart
        </span>
      </div>
      <ContainerStatus
          origin={{
            origin_id: firstOrigin?.origin_id,
            origin_name: firstOrigin?.origin_name,
            vtweg: firstOrigin?.vtweg,
          }}
          headerOverride={popupHeader}
        />
      <div className="details mb1 mr1">
        <label>CART</label>
        <div>
          <span>
            {cart?.line_items?.length} Items | Total $
            {amountFormat(cart?.total_price)}
          </span>
        </div>
      </div>
    </div> : null
  );
};

export default CartPopup;